import WorkExperiencePage from './WorkExperience.page';

export default WorkExperiencePage;
